// removed by extract-text-webpack-plugin
module.exports = {"pirate":"Pirate__pirate___epSVM","draggable":"Pirate__draggable___1ivsk","isDragging":"Pirate__isDragging___JXgHg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pirate/Pirate.css
// module id = 325
// module chunks = 0